<div class="flex__child--auto flex--column" data-test="contactperson">
  <router-outlet></router-outlet>
</div>
